import { envs } from 'application/envHandler'
import apiClient from 'core/api/client'
import getMockedDVBCHistoryData from 'testing/rftuning/DVBCHistory'

export default async function fetchCurrentDVBCData(deviceId: string) {
  if (process.env.NODE_ENV === 'development' && envs.REACT_APP_USE_LOCAL_MOCKED_DATA) {
    const data = await getMockedDVBCHistoryData()

    return { ...data }
  }

  return apiClient.get(`${envs.REACT_APP_API_URL}/dvbc/device/${deviceId}`)
}